<script>
  import icons from '@storytel/storytel-icon-library';

  export let iconName;
  export let inlineStart = false,
    blockStart = false,
    blockEnd = false,
    size = null,
    rtlFlip = false,
    rtlMirror = false,
    iconType = 'regular',
    styles = {};

  const inlineEnd = !inlineStart && !blockStart && !blockEnd;

  $: icon = icons
    .sort((a, b) => {
      if (a.name === b.name) {
        if (a.type === 'regular') {
          return -1;
        } else {
          return 1;
        }
      }

      return a.name > b.name ? 1 : -1;
    })
    .find(
      (icon) =>
        (icon.name === iconName || icon.alternativeNames.includes(iconName)) &&
        (iconType === 'regular' || icon.type === iconType)
    );

  // map styles object to string
  const style = Object.entries(styles).reduce((acc, cur) => `${acc}${cur[0]}:${cur[1]};`, '');
</script>

<style lang="scss">
  .blockEnd {
    transform: rotate(90deg);
  }

  .blockStart {
    transform: rotate(270deg);
  }

  .inlineStart {
    transform: rotate(180deg);
  }

  :global([dir='rtl']) .inlineEnd.rtlFlip {
    transform: rotate(180deg);
  }

  :global([dir='rtl']) .inlineStart.rtlFlip {
    transform: rotate(0deg);
  }

  :global([dir='rtl']) .rtlMirror {
    transform: scaleX(-1);
  }
</style>

{#if icon}
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size || icon.width}
    height={size || icon.height}
    viewBox={icon.viewBox}
    {style}
    role="img"
    aria-label={icon.name}
    class:inlineStart
    class:blockStart
    class:blockEnd
    class:inlineEnd
    class:rtlFlip
    class:rtlMirror
  >
    {@html icon.html}
  </svg>
{/if}
